import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ChatHeader = ({ agent, onClose, onMinimize, showMinimize = false }) => {
  return (
    <div className="flex items-center justify-between p-4 bg-card border-b border-border">
      <div className="flex items-center space-x-3">
        <div className="relative">
          <Image
            src={agent.avatar}
            alt={agent.name}
            className="w-10 h-10 rounded-full object-cover"
          />
          <div className={`absolute bottom-0 right-0 w-3 h-3 rounded-full border-2 border-card ${
            agent.isOnline ? 'bg-success' : 'bg-muted'
          }`} />
        </div>
        <div>
          <h3 className="font-medium text-foreground">{agent.name}</h3>
          <p className="text-sm text-muted-foreground">
            {agent.isOnline ? 'Online' : `Last seen ${agent.lastSeen}`}
          </p>
        </div>
      </div>
      
      <div className="flex items-center space-x-2">
        {showMinimize && (
          <Button
            variant="ghost"
            size="icon"
            onClick={onMinimize}
            className="w-8 h-8"
          >
            <Icon name="Minus" size={16} />
          </Button>
        )}
        <Button
          variant="ghost"
          size="icon"
          onClick={onClose}
          className="w-8 h-8"
        >
          <Icon name="X" size={16} />
        </Button>
      </div>
    </div>
  );
};

export default ChatHeader;